export class ComponentRoleModel {
    public componentId?: number;
    public roleId?: string;
    public activeId?: number;
}
